import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/enviroments/environment';
import { ApiResponse } from './api-response.interface';
import { Permission, RolePermissionsUpdate, AvailableModule } from '../interfaces/permission.interface';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  private apiUrl = `${environment.apiUrl}`;
  private rolesUrl = `${environment.apiUrl}/roles`;

  constructor(private http: HttpClient) { }

  /**
   * GET /permissions - Obtener todos los permisos
   */
  getPermissions(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.apiUrl);
  }

  /**
   * GET /permissions/modules - Obtener lista de módulos disponibles
   */
  getAvailableModules(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${this.apiUrl}/modules`);
  }

  /**
   * GET /permissions?idRol={roleId} - Obtener permisos guardados de un rol específico
   */
  getRolePermissions(roleId: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${this.apiUrl}/permissions?idRol=${roleId}`);
  }

  /**
   * POST /permissions/role/{roleId} - Crear permisos nuevos de un rol
   * Body: Array de permisos con IdRol, IdModule, CanView, CanCreate, CanEdit, CanDelete
   */
  createRolePermissions(roleId: number, permissions: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${this.apiUrl}/permissions/role/${roleId}`, permissions);
  }

  /**
   * PUT /permissions/role/{roleId} - Actualizar permisos existentes de un rol
   * Body: Array de permisos con IdRolPermission, IdRol, IdModule, CanView, CanCreate, CanEdit, CanDelete
   */
  updateRolePermissions(roleId: number, permissions: any): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`${this.apiUrl}/permissions/role/${roleId}`, permissions);
  }

  /**
   * GET /permissions/user/:userId - Obtener permisos de un usuario específico
   * userId debe ser el UserCode del usuario
   */
  getUserPermissions(userId: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${this.apiUrl}/permissions/user/${userId}`);
  }
}
